<template lang="pug">
  ProgramSettingsFormWrapper(
    setting-type="settings"
    :form-data="formData"
    :disable-save.sync="disableSave"
    @reset="resetProgramLogo"
    :keys-to-reset="[]"
    title="Program Logo"
  )
    ContentLoader(:width="300" :height="120" v-if="!programLoaded")
      rect(x="0", y="0", rx="4", ry="4", width="45%", height="100")
    .columns(v-else)
      .column
        WtUploadImage(
          entity="program"
          :currentImage.sync="currentProgramLogo"
          @updateImage="onProgramLogoUpdate"
          :imageSize="'256 x 256'"
        )
          template(v-slot:label)
            WtLabel(text="Program Logo")
</template>

<script>
import { mapGetters } from "vuex";
import { ContentLoader } from "vue-content-loader";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import WtUploadImage from "@@/WtUploadImage/WtUploadImage";
import WtLabel from "@@/WtLabel/WtLabel";
import ProgramSettingsFormWrapper from "./ProgramSettingsFormWrapper";

export default {
  name: "ProgramLogoSettings",

  components: {
    ContentLoader,
    ProgramSettingsFormWrapper,
    WtLabel,
    WtUploadImage
  },

  mixins: [programSettingsFormMixin],

  data() {
    return {
      currentProgramLogo: null,
      newProgramLogo: null
    };
  },

  computed: {
    ...mapGetters("program", ["programLoaded", "programSettingsCopy"]),

    formData() {
      const data = new FormData();

      if (this.newProgramLogo) {
        data.set("programLogo", this.newProgramLogo);
      }

      return data;
    }
  },

  watch: {
    programSettingsCopy: {
      handler(newValue) {
        if (!this.newProgramLogo) {
          this.currentProgramLogo = this._.get(newValue, "programLogo", null);
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    onProgramLogoUpdate(file) {
      this.newProgramLogo = file;
      this.disableSave = !file;
    },

    resetProgramLogo() {
      this.newProgramLogo = null;
      this.currentProgramLogo = this._.get(
        this.programSettingsCopy,
        "programLogo",
        null
      );
      this.disableSave = true;
    }
  }
};
</script>
